"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureMaterialVolume = measureMaterialVolume;
/// <reference lib="es2022.intl" />
const textSizes_1 = require("../constants/textSizes");
const textTokenizer_1 = require("../utils/textTokenizer");
/** Own materials use the C2 upper bound, independently of the chosen level. */
function measureMaterialVolume(content, language) {
    const { max, unit } = (0, textSizes_1.getTextLengthRange)("LONG", language);
    const count = unit === "characters"
        ? Array.from(content.replace(/\s/gu, "")).length
        : typeof Intl.Segmenter !== "function"
            ? (0, textTokenizer_1.countWords)(content, language)
            : Array.from(new Intl.Segmenter(language, { granularity: "word" }).segment(content)).filter((segment) => segment.isWordLike === true).length;
    return { count, max, unit, valid: count > 0 && count <= max };
}
//# sourceMappingURL=materialVolume.js.map